export default __webpack_public_path__ + "static/media/step_5.7092ad00.jpg";